export const homeURL="/"
export const appVersion='1'
//export const portalURL="https://www.arcgis.com"
export const popupCallbackURL=process.env.REACT_APP_POPUPCALLBACKURL
export const googleAPIKey=process.env.REACT_APP_GOOGLE_KEY

export const esriOauthAppId_AGOL=process.env.REACT_APP_ESRI_APP_ID_AGOL
export const esriOauthAppId_OCPWPORTAL=process.env.REACT_APP_ESRI_APP_ID_OCPWPORTAL

export const esriOauthAppId_OCPWPORTAL_DEV=process.env.REACT_APP_ESRI_APP_ID_OCPWPORTAL_DEV

export const arcgis_api_key_dev_org=process.env.REACT_APP_ARCGIS_API_KEY_DEV_ORG

export const arcgis_api_key_ocpw_org=process.env.REACT_APP_ARCGIS_API_KEY_OCPW_ORG

export const internallayerNameList =['nccpReserve', 'sshpRMVHabitatReserve', 'ocParksTrails', 
    'tncConservationEasement', 'eoConservationEasement','irvineRegionalParkDonation', 
    'mpConservationEasement', 'basinsAndDams']
